(function () {
  'use strict';

  /* @ngdoc object
   * @name login.forgotten
   * @description
   *
   */
  angular
    .module('login.forgotten', [
      'ui.router'
    ]);
}());
